import React, { ReactElement } from 'react';
import {
	Box,
	Button,
	CardMedia,
	Container,
	List,
	ListItem,
	ListItemText
} from '@material-ui/core';

import { getSearchHistory } from '../../../services';
import {
	LoadingContainer,
	Header3,
	Header4,
	Body2,
	Header5
} from '../../atoms';
import { SearchBar, SearchBarProvider } from '..';
import { getLastViewed, MapViewerLastViewed } from '../../../redux';
import { CardTemplate } from '../../molecules';
import { useHistory } from 'react-router';

import './search-result-empty.styles.scss';
import { Trans, useTranslation } from 'react-i18next';

export interface ISearchResultEmptyProps {
	selectable: boolean;
	searchValue: string;
	search: (searchValue: string) => void;
	onNavigateToIndex: () => void;
}

export function SearchResultEmpty(
	props: ISearchResultEmptyProps
): ReactElement {
	const { searchValue, selectable, search, onNavigateToIndex } = props;
	const lastOpenedMaps: MapViewerLastViewed[] = getLastViewed();
	const history = useHistory();
	const { t } = useTranslation('search');

	return (
		<Container className="search-result-empty">
			<SearchBarProvider disableDropdown disableNavigation autoFocus>
				<SearchBar />
			</SearchBarProvider>
			<LoadingContainer sections={['search']}>
				<Box className="previous-searchterms">
					<Header4>{t('prevSearched')}</Header4>
					<List className="previously-searched-history">
						{getSearchHistory().map(
							(historyItem: string, index: number) => (
								<ListItem
									onClick={() => search(historyItem)}
									key={index}
									button
								>
									<ListItemText primary={historyItem} />
								</ListItem>
							)
						)}
					</List>
				</Box>
				<Box className="search-results-empty-body">
					{searchValue.length > 0 && (
						<>
							<Header3 className="no-results-text">
								<Trans
									i18nKey={'search:noResultsFoundFor'}
									values={{ searchValue }}
									components={{ bold: <strong /> }}
									defaults='No results found for "<bold>{{searchValue}}</bold>"'
								/>
							</Header3>

							<Header4>{t('searchTips')}</Header4>
							<Body2>{t('correctSpelling')}</Body2>
							<ul>
								<li>
									<Body2>
										{t('searchOptions.mapNumber')}
									</Body2>
								</li>
								<li>
									<Body2>
										{t('searchOptions.pageNumber')}
									</Body2>
								</li>
								<li>
									<Body2>{t('searchOptions.titleMap')}</Body2>
								</li>
								<li>
									<Body2>{t('searchOptions.keyword')}</Body2>
								</li>
							</ul>
						</>
					)}

					<Header4>{t('searchWithIndex')}</Header4>
					<Button
						color="primary"
						variant="outlined"
						onClick={onNavigateToIndex}
					>
						{t('goToIndex')}
					</Button>

					<Header4>{t('prevSearched')}</Header4>
					<Box className="previously-searched-container">
						{!selectable && (
							<Box className="previously-viewed">
								{lastOpenedMaps.map(
									(lastViewed: MapViewerLastViewed) => (
										<CardTemplate
											big
											key={lastViewed.mapId}
											image={
												<CardMedia
													component="img"
													image={lastViewed.mapUrl}
													className="cursor-pointer"
												/>
											}
											onClick={() =>
												history.push(
													`/map/${lastViewed.mapId}`
												)
											}
										>
											<Header5>
												{lastViewed.title}
											</Header5>
										</CardTemplate>
									)
								)}
							</Box>
						)}
					</Box>
				</Box>
			</LoadingContainer>
		</Container>
	);
}
